export const RESTAURANTS = [
  {
    id: "ma-biche",
    index: "01",
    name: "Ma Biche sur le Toit",
    tag: "Rooftop · Vue panoramique",
    logo: "/logos/ma-biche-white.png",
    logoClass: "h-16 md:h-20",
    logoClassSm: "h-12",
    description:
      "Le rooftop iconique de Toulouse, perché au 6e étage des Galeries Lafayette. Table gastronomique sous les étoiles, puis cocktails, DJ et ambiance club au fil de la nuit : ici, le dîner se transforme en fête au-dessus de la ville rose.",
    address: "4–8 rue du Lieutenant-Colonel Pélissier, 31000 Toulouse",
    hours: "Lun–Ven 10h–2h · Sam 10h–3h · Dim fermé",
    image: "/photos/ma-biche.jpg",
    link: "https://www.mabichesurletoit.com/reservation/",
  },
  {
    id: "compagnie-francaise",
    index: "02",
    name: "Compagnie Française Jeanne d'Arc",
    tag: "Brasserie · Esprit italien",
    logo: "/logos/compagnie-francaise-white.png",
    logoClass: "h-10 md:h-12",
    logoClassSm: "h-7",
    description:
      "L'élégance à l'italienne au cœur de la ville rose, dans une brasserie majestueuse à deux pas du Capitole.",
    address: "56–58 rue d'Alsace-Lorraine, 31000 Toulouse",
    hours: "Tous les jours 9h–00h30",
    image: "/photos/compagnie-francaise.jpg",
    link: "https://bookings.zenchef.com/results?rid=348976&type=web&pid=1001&mini=&lang=en",
  },
  {
    id: "cafe-chouchou",
    index: "03",
    name: "Café Chouchou",
    tag: "Bistrot · Esprit Carmes",
    logo: "/logos/cafe-chouchou-white.png",
    logoClass: "h-10 md:h-12",
    logoClassSm: "h-7",
    description:
      "Bistrot chaleureux et convivial des Carmes — l'esprit brasserie réinventé, du déjeuner au dernier verre.",
    address: "37 rue des Filatiers, 31000 Toulouse",
    hours: "Tous les jours 11h–23h45",
    image: "/photos/cafe-chouchou.jpg",
    link: "https://www.cafe-chouchou.fr/",
  },
  {
    id: "coup-de-bambou",
    index: "04",
    name: "Coup de Bambou",
    tag: "Bistrot · Bar à tapas",
    description:
      "L'évasion culinaire sur la place Saint-Georges : tapas, cocktails et ambiance tamisée jusqu'au bout de la nuit.",
    address: "12 place Saint-Georges, 31000 Toulouse",
    hours: "Tous les jours 8h–2h",
    logo: "/logos/coup-de-bambou-white.png",
    logoClass: "h-14 md:h-16",
    logoClassSm: "h-8",
    ctaLabel: "Notre site internet",
    note: "Sans réservation",
    image: "/photos/coup-de-bambou.jpg",
    link: "https://coupdebambou.fr/",
  },
  {
    id: "compagnie-francaise-busca",
    index: "05",
    name: "Compagnie Française Busca",
    tag: "Café · Brasserie du Busca",
    description:
      "Le petit frère de la Compagnie Française, au cœur du quartier du Busca : café de quartier le jour, table conviviale le soir.",
    address: "17 rue Sainte-Catherine, 31400 Toulouse",
    hours: "Lun–Sam 12h–14h · 19h–22h",
    image: "/photos/compagnie-francaise-busca.jpg",
    logo: "/logos/busca-white.png",
    logoClass: "h-12 md:h-16",
    logoClassSm: "h-8",
    link: "https://bookings.zenchef.com/results?rid=370193&pid=1001",
  },
];
